export default __webpack_public_path__ + "static/media/youtube-logo.b22701a0.svg";